module.exports = __webpack_public_path__ + "static/background-829048f502481f8c44b0c59aada51c56.png";